import PropTypes from 'prop-types';
import { forwardRef } from 'react';

import Box from '@mui/material/Box';
import Link from '@mui/material/Link';

import { RouterLink } from 'src/routes/components';

import Image from '../image';
import { useSettingsContext } from '../settings';

// ----------------------------------------------------------------------

const Logo = forwardRef(({ disabledLink = false, sx, }, ref) => {
  const settings = useSettingsContext();

  const darkStyle = {
    width: 100,
    height: 70,
  }


  const logo = (
    <Box
      ref={ref}
      component="div"
      sx={{
        ...(settings?.themeMode === 'dark' ? darkStyle : { width: 100, height: 80 }),
        display: 'inline-flex',
        ...sx,
      }}
    >
      {settings?.themeMode === 'light' ?
        <Image
          loading='eager'
          alt="ziyaq"
          title="ziyaq"
          src="/logo/main-logo.webp"
          ratio="1/1"
          sx={{}}
          imageStyle={{
            width: 100,
            height: 80,
            objectFit: "contain",
            cursor: "pointer",
            ...sx,
          }}
        />
        :

        <Image
          loading='eager'
          alt="ziyaq"
          title="ziyaq" src="/logo/dark-logo.png"
          ratio="1/1"
          sx={{}}
          imageStyle={{
            width: 100, height: 70, objectFit: "contain",
            cursor: 'pointer', ...sx
          }}
        />
      }
    </Box >
  );

  if (disabledLink) {
    return logo;
  }


  return (
    <Link component={RouterLink} href="/" sx={{ display: 'contents' }}>
      {logo}
    </Link>
  );
});

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default Logo;
